import { z } from "zod";
import { optionalCnpjSchema } from "../common/document";
import { requiredAddressSchema } from "./address";
import { organizationTypeSchema } from "./types";

/** Criação de organização de equipe (via "+ Criar organização" no seletor ou em /organizacoes). */
export const organizationCreateSchema = z.object({
  name: z.string().trim().min(2, "Nome muito curto").max(120),
  document: optionalCnpjSchema,
  address: requiredAddressSchema,
  types: z.array(organizationTypeSchema).min(1, "Selecione ao menos uma área").max(3),
  /** Organização (do mesmo tipo, da qual a pessoa é dona) de onde copiar catálogo e configurações. */
  copiarDe: z.string().min(1).optional(),
  /** Clínica do zero: especialidades (opcionais) — os procedimentos delas entram na criação. */
  especialidadeIds: z.array(z.string().min(1)).max(40).default([]),
});

export type OrganizationCreateInput = z.infer<typeof organizationCreateSchema>;
